import { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../../../components/Footer/Footer";
import SuccessIcon from "../../../../assets/icons/order-placed.gif";
import SuccessIconlast from "../../../../assets/icons/Success-Icon.png";
import "../styles/SuccessPage.css";
import { formatDate } from "../../../../utils/date.utils";
import AddonItems from "../components/AddonItems";
import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";
import { fetchAddOns } from "../../../products/topPicks/redux/topPicksSlice";

const Successpage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [showGif, setShowGif] = useState(true);
  const verifyResponse = location.state?.verifyResponse;
  const { addOns = [] } = useSelector((state) => state.toppick || {});
  console.log("Add-ons fetched for success page:", addOns);
  useEffect(() => {
    document.title = "Obsessions - Order Confirmation";
    // If user refreshes or directly opens this page
    if (!verifyResponse?.data) {
      navigate("/", { replace: true });
      return;
    }
    dispatch(fetchAddOns());

  //   dispatch(fetchAddOns());
  // }, [dispatch, navigate, verifyResponse]);

    const timer = setTimeout(() => {
        setShowGif(false);
      }, 1000); // duration adjust kar sakte ho
      return () => clearTimeout(timer);
    }, [dispatch, navigate, verifyResponse]);

  const orderData = verifyResponse?.data;
  const formattedDate = formatDate(orderData?.created_at);
  const order_number = orderData?.order_no;
  return (
    <>
      <Breadcrumbs paths={[{ label: "Order Placed" },{ label: order_number,to:`/accounts/orders/${orderData?.order_no}` }]} />
      <div className="success-container">
       <div className="mb-0">
          {showGif ? (
            <img src={SuccessIcon} alt="Payment Success" width={140} />
          ) : (
            <img src={SuccessIconlast} alt="Payment Success" width={140} />
          )}
        </div>

        <h2 className="success-title">Order Placed Successfully</h2>
        <p className="success-subtitle">Thank you for shopping with us!</p>

        <div className="arrival-box">
          <p className="arrival-id">
            Order Placed: <span>{formattedDate}</span>
          </p>
          <p className="arrival-id-order">
            Order ID: <span>{orderData?.order_no || "--"}</span>
          </p>
        </div>

        <div className="button-group">
          <Link to={`/accounts/orders/${orderData?.order_no}`}>
            <button className="btn-outline">View Order</button>
          </Link>

          <button
            onClick={() => navigate("/")}
            className="btn-outline-continue"
          >
            Continue Shopping
          </button>
        </div>
      </div>
      <AddonItems />
      <Footer />
    </>
  );
};

export default Successpage;